<div class="row">
  <div *ngIf="balance" class="col-12 col-sm-3">
    <h4>profile</h4>
    <div class="bg-white py-3">
      <img *ngIf="imageSrc" class="rounded-circle mx-auto d-block" style="width: 70%;"
           height="150" width="150" [src]="sanitizer.bypassSecurityTrustUrl(imageSrc)" alt="selectedFile.name" />
      <br>
      <p style="text-align:center;font-size:70%">{{businessName}}</p>
      <p style="font-size:70%;text-align:center">{{email}}</p>
      <p style="font-size:70%;text-align:center">{{phone}} </p>
      <hr>
      <div style="color:mediumpurple ; text-align:center">
        <p style="font-size:80%"> Total Sales</p>
      </div>
      <div style="color:rgb(219, 52, 52); text-align:center">
        <strong style="font-size:80%"> {{balance.totalSales}}</strong>
      </div>
      <hr>
      <div style="color:mediumpurple ; text-align:center">
        <p style="font-size:80%"> Pending Balance</p>
      </div>
      <div style="color:rgb(219, 52, 52); text-align:center">
        <strong style="font-size:80%"> {{balance.pendingBalance}}</strong>
      </div>
      <hr>
      <div style="color:mediumpurple ; text-align:center">
        <p style="font-size:80%"> Available Balance</p>
      </div>
      <div style="color:rgb(219, 52, 52); text-align:center">
        <strong style="font-size:80%"> {{balance.avalibleBalance}}</strong>
      </div>
      <hr>
      <div style="color:mediumpurple ; text-align:center">
        <p style="font-size:80%">Total Balance</p>
      </div>
      <div style="color:rgb(219, 52, 52); text-align:center">
        <strong style="font-size:80%"> {{balance.totalBalnce}}</strong>
      </div>
      <hr>
      <div style="color:mediumpurple ; text-align:center">
        <p style="font-size:80%"> Total Withdrawals</p>
      </div>
      <div style="color:rgb(219, 52, 52); text-align:center">
        <strong style="font-size:80%"> {{balance.totalWithDrawls}}</strong>
      </div>
      <hr>
      <div style="color:mediumpurple ; text-align:center">
        <p style="font-size:80%"> Cash Wallet Balance</p>
      </div>
      <div style="color:rgb(219, 52, 52); text-align:center">
        <strong style="font-size:80%"> {{balance.netWithdrawalsCashoutBalance}}</strong>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-9">
    <mat-tab-group>
      <mat-tab label="User Product">
        <app-products-report [businessId]="businessId"></app-products-report>
      </mat-tab>
      <mat-tab *ngIf="businessInfo && businessPermission" label="Update Profile">
        <app-business-profile [data]="businessInfo"></app-business-profile>
      </mat-tab>
      <mat-tab *ngIf="businessInfo && profilePermission" label="Business Information">
        <app-business-info [oldValues]="businessInfo" [isAdmin]="true" [businessId]="businessId"></app-business-info>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
